export const dataLibK = [{
  word: 'koko',
  partOfSpeech: 'N',
  definition: ['coconut'],
  egSentenceKw: 'Vòlè-a tjouwi tout koko-a an jaden mwen.',
  egSentenceEn: 'The thief picked all of the coconuts in my garden.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. coco]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kanmizòl',
  partOfSpeech: 'N',
  definition: ['coat', 'jacket', 'suitcoat', 'sportcoat'],
  egSentenceKw: 'I mété kwavat-la épi kanmizòl li.',
  egSentenceEn: 'He put on his tie and jacket.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. camisole]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kalson',
  partOfSpeech: 'N',
  definition: ['drawers', 'underpants'],
  egSentenceKw: 'Madanm-lan achté kalson bay mawi\'y.',
  egSentenceEn: 'The woman bought underpants for her husband.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'katapòl',
  partOfSpeech: 'N',
  definition: ['slipper', 'thong', 'sandal', 'flipflop'],
  egSentenceKw: 'I mété kouwi épi katapòl li volé sòti an pyé\'y.',
  egSentenceEn: 'He started running and his slipper flew off his foot.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. catapulte]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kwavat',
  partOfSpeech: 'N',
  definition: ['necktie'],
  egSentenceKw: 'I mété an kwavat nwè pou i alé lètèman-an.',
  egSentenceEn: 'He put on a black tie to go to the funeral.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cravate]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kounoumounou',
  partOfSpeech: 'N',
  definition: ['fool'],
  egSentenceKw: 'Gason-an sé on kounoumounou!',
  egSentenceEn: 'The boy is a fool!',
  synonym: ['kouyon', 'kouyon', 'lèlè'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ka',
  partOfSpeech: 'ADV',
  definition: ['progressive aspect marker'],
  egSentenceKw: 'I ka palé.',
  egSentenceEn: 'He is speaking.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kay',
  partOfSpeech: 'ADV',
  definition: ['future tense indicator'],
  egSentenceKw: 'Denmen nou kay pati.',
  egSentenceEn: 'Tomorrow we will depart.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kay',
  partOfSpeech: 'N',
  definition: ['house, building'],
  egSentenceKw: 'I ja ni dé lanné dépi misyé-a koumansé kay-la épi i p\'òkò sa wèsté adan\'y jik toujou.',
  egSentenceEn: 'It has already been two years since the man began to build the house and he still can\'t live in it yet.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['kaz'],
}, {
  word: 'kabwès',
  partOfSpeech: 'N',
  definition: ['young girl'],
  egSentenceKw: 'Mi kabwès-la la',
  egSentenceEn: 'Look at the young girl there!',
  synonym: ['tifi', 'tifi'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ki',
  partOfSpeech: 'ADJ',
  definition: ['what', 'which'],
  egSentenceKw: 'Ki jou ou vlé yo sòti?',
  egSentenceEn: 'What day do you want them to leave?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. qui]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ki',
  partOfSpeech: 'CONJ',
  definition: ['that', 'which', 'who'],
  egSentenceKw: 'Sé pou ou fè bagay ki ka plè nou.',
  egSentenceEn: 'You must do things that please us.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. qui]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kozé',
  partOfSpeech: 'V',
  definition: ['to chat'],
  egSentenceKw: 'Sé nonm-lan ka jwé dòmino épi sé madanm-lan ka kozé.',
  egSentenceEn: 'The men are playing dominoes and the women are chatting.',
  synonym: ['diskasyon', 'pale'],
  antonym: [null],
  etymology: '[< Fr.causer]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kondwi',
  partOfSpeech: 'V',
  definition: ['to lead', 'to control', 'to rule', 'to reign'],
  egSentenceKw: 'Nonm-lan pa sa menm kondwi kay li.',
  egSentenceEn: 'The man cannot even rule his household.',
  synonym: ['diwèkté', 'djidé', 'drayv', 'gouvèné'],
  antonym: [null],
  etymology: '[< Fr.conduire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kondwi',
  partOfSpeech: 'V',
  definition: ['to drive'],
  egSentenceKw: 'Mwen pa kontan mannyè madanm-lan ka kondwi motoka-a.',
  egSentenceEn: 'I don\'t like the way the woman is driving the car.',
  synonym: ['drayv'],
  antonym: [null],
  etymology: '[< Fr.conduire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ka',
  partOfSpeech: 'V',
  definition: ['care'],
  egSentenceKw: 'Bondyé kay pwan ka\'w.',
  egSentenceEn: 'God will take care of you.',
  synonym: ['gadé apwé', 'otjipé'],
  antonym: [null],
  etymology: '[< Eng. care]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kanmèl',
  partOfSpeech: 'N',
  definition: ['camel'],
  egSentenceKw: 'Lè i wivé bò pi-a, i fè sé kanmèl-la kouché.',
  egSentenceEn: 'When he arrived near the well, he made the camels lie down.',
  synonym: ['chanmo'],
  antonym: [null],
  etymology: '[< Eng. camel]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kanp',
  partOfSpeech: 'N',
  definition: ['camp', 'camping'],
  egSentenceKw: 'Légliz-la ka alé kanp lòt simenn.',
  egSentenceEn: 'The church is going camping next week.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. camp]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kapa',
  partOfSpeech: 'N',
  definition: ['small change', 'a small amount of money in coins'],
  egSentenceKw: 'Pòl ni on fyòl asou létajè\'y ki benyen kapa.',
  egSentenceEn: 'Paul has a jar on his shelf that is full of small change.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. copper]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kawozin',
  partOfSpeech: 'N',
  definition: ['kerosene'],
  egSentenceKw: 'Boutèy-la té plen kawozin.',
  egSentenceEn: 'The bottle was full of kerosene.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. kerosene]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kés',
  partOfSpeech: 'N',
  definition: ['court', 'court case'],
  egSentenceKw: 'I mouté désann konsèy pou dé lanné avan kés-la pawèt.',
  egSentenceEn: 'He went up and down to high court for two years before they called the case.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. case]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kòlvèt',
  partOfSpeech: 'N',
  definition: ['culvert', 'underground drain'],
  egSentenceKw: 'Dlo-a lavé chimen-an paski kòlvèt-la bouché.',
  egSentenceEn: 'The water washed away the road because the culvert was blocked.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. culvert]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'konpyouta',
  partOfSpeech: 'N',
  definition: ['computer'],
  egSentenceKw: 'Mwen achté on konpyouta bay sé manmay-la.',
  egSentenceEn: 'I bought a computer for the children.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. computer]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kòrèk',
  partOfSpeech: 'ADJ',
  definition: ['good', 'okay', 'well'],
  egSentenceKw: 'Ès ou kòrèk?',
  egSentenceEn: 'Are you okay?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. correct]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Kwéyòl',
  partOfSpeech: 'N',
  definition: ['Creole language'],
  egSentenceKw: 'Yo pa ka palé Kwéyòl.',
  egSentenceEn: 'They don\'t speak Creole.',
  synonym: ['Patwa'],
  antonym: [null],
  etymology: '[< Fr. créole]',
  dialect: '🇱🇨',
  variant: ['Kéwòl'],
}, {
  word: 'Kwéyòl',
  partOfSpeech: 'N',
  definition: ['person of African descent'],
  egSentenceKw: 'Papa mwen sé on Kwéyòl, manman mwen sé on Kouli.',
  egSentenceEn: 'My father is of African descent and my mother is of East Indian descent.',
  synonym: ['Patwa'],
  antonym: [null],
  etymology: '[< Fr. créole]',
  dialect: '🇱🇨',
  variant: ['Kéwòl'],
}, {
  word: 'konsèné',
  partOfSpeech: 'V',
  definition: ['to concern'],
  egSentenceKw: 'Sa mwen ka di-a pa ka konsèné\'w.',
  egSentenceEn: 'What I am saying doesn\'t concern you.',
  synonym: ['asou'],
  antonym: [null],
  etymology: '[< Fr. concerner]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'konsèné',
  partOfSpeech: 'PREP',
  definition: ['about', 'concerning'],
  egSentenceKw: 'Sa mwen ka di-a pa ka konsèné\'w.',
  egSentenceEn: 'Mwen vlé palé ba\'w konsèné sé zannimo\'w-la ki ladjé-a.',
  synonym: ['asou'],
  antonym: [null],
  etymology: '[< Fr. concerner]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kont',
  partOfSpeech: 'PREP',
  definition: ['against'],
  egSentenceKw: 'Sésé mwen palé kont mwen an lodyans-lan.',
  egSentenceEn: 'My sister spoke against me in court.',
  synonym: [null],
  antonym: ['an favè'],
  etymology: '[< Fr. contre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kont',
  partOfSpeech: 'PREP',
  definition: ['about', 'because of'],
  egSentenceKw: 'Mwen faché kont bonm-lan ki tonbé-a.',
  egSentenceEn: 'I am upset about the bucket that fell over.',
  synonym: [null],
  antonym: ['an favè'],
  etymology: '[< Fr. contre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kanna',
  partOfSpeech: 'N',
  definition: ['duck'],
  egSentenceKw: 'Sé moun sala benyen kanna bò kay yo.',
  egSentenceEn: 'Those people have a lot of ducks by their house.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. canard]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kawouj',
  partOfSpeech: 'N',
  definition: ['St. Lucia oriole'],
  egSentenceKw: 'Kawouj sé yonn an sé pli bèl jibyé-a ki St. Lisi, i ni koulè jòn èk nwè.',
  egSentenceEn: 'The oriole is one of the most beautiful birds in St. Lucia, it\'s colored yellow and black.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kayal',
  partOfSpeech: 'N',
  definition: ['egret', 'heron', 'cowbird'],
  egSentenceKw: 'Lè lapli sé savann-an ka benyen kayal.',
  egSentenceEn: 'In the rainy season the fields are full of egrets.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kilibwi',
  partOfSpeech: 'N',
  definition: ['hummingbird'],
  egSentenceKw: 'Kilibwi ka sisé flè.',
  egSentenceEn: 'Hummingbirds suck flowers.',
  synonym: ['sisi Bondyé'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['koulibwi'],
}, {
  word: 'kòbo',
  partOfSpeech: 'N',
  definition: ['vulture'],
  egSentenceKw: 'Kòbo ka manjé tout bagay ki mò avan\'y.',
  egSentenceEn: 'Vultures eat anything that dies before them.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. corbeau]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kodenn',
  partOfSpeech: 'N',
  definition: ['turkey'],
  egSentenceKw: 'Nou manjé an gwo kodenn pou Nwèl.',
  egSentenceEn: 'We ate a big turkey for Christmas.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kòk',
  partOfSpeech: 'N',
  definition: ['cock', 'rooster'],
  egSentenceKw: 'Apwé kòk-la chanté mwen pa té sa dòmi ankò.',
  egSentenceEn: 'After the rooster crowed I couldn\'t sleep any more.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. coq]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'koukou manyòk',
  partOfSpeech: 'N',
  definition: ['mangrove cuckoo.'],
  egSentenceKw: 'Mwen pa konnèt pyès jibyé ki pli dous pasé koukou manyòk.',
  egSentenceEn: 'I don\'t know any bird that\'s tamer than the mangrove cuckoo.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kwabyé',
  partOfSpeech: 'N',
  definition: ['great blue heron', '(Ardea herodias)'],
  egSentenceKw: 'Kwabyé ka manjé pwéson.',
  egSentenceEn: 'Herons eat fish.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['kabyé'],
}, {
  word: 'kilès',
  partOfSpeech: 'ADJ',
  definition: ['which'],
  egSentenceKw: 'Kilès motoka ou simyé?',
  egSentenceEn: 'Which car do you prefer?',
  synonym: ['ki moun ki', 'sa ki'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'konmen',
  partOfSpeech: 'ADJ',
  definition: ['how much', 'how many'],
  egSentenceKw: 'Konmen lajan ou ni?',
  egSentenceEn: 'How much money do you have?',
  synonym: ['an pil'],
  antonym: [null],
  etymology: '[< Fr. combien]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'konmen',
  partOfSpeech: 'ADJ',
  definition: ['so much', 'so many'],
  egSentenceKw: 'Magwé konmen lanné té ja pasé, i té ka chonjé méchansté-a yo té fè\'y-la toujou.',
  egSentenceEn: 'Although many years had passed, he still remembered the bad thing they had done to him.',
  synonym: ['an chay', 'an pil', 'anbadjo', 'mizi', 'plizyè'],
  antonym: [null],
  etymology: '[< Fr. combien]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'konmen',
  partOfSpeech: 'ADJ',
  definition: ['common'],
  egSentenceKw: 'Sété on bagay ki konmen.',
  egSentenceEn: 'It was a common thing.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. commun]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'koté',
  partOfSpeech: 'N',
  definition: ['side'],
  egSentenceKw: 'Nou ka alé lòt koté-a.',
  egSentenceEn: 'We\'re going to the other side.',
  synonym: ['bò, fasad, sayd'],
  antonym: [null],
  etymology: '[< Fr. coté]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'koté',
  partOfSpeech: 'N',
  definition: ['house', 'place'],
  egSentenceKw: 'Yo alé koté Pita èk yo mandé\'y lajan.',
  egSentenceEn: 'They went to Pita\'s place and asked him for money.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. coté]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'koté',
  partOfSpeech: 'ADV',
  definition: ['wherever'],
  egSentenceKw: 'Koté ou alé, mwen dèyè\'w.',
  egSentenceEn: 'Wherever you go, I\'ll find you.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. coté]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kon',
  partOfSpeech: 'CONJ',
  definition: ['as', 'like'],
  egSentenceKw: 'Zòt ka swiv misyé-a kon mouton.',
  egSentenceEn: 'You are following the man like sheep.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. comme]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kon',
  partOfSpeech: 'CONJ',
  definition: ['when', 'as'],
  egSentenceKw: 'Kon i wivé i wè lapen-an.',
  egSentenceEn: 'When he arrived he saw the rabbit.',
  synonym: ['lè'],
  antonym: [null],
  etymology: '[< Fr. comme]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kon',
  partOfSpeech: 'CONJ',
  definition: ['as well as'],
  egSentenceKw: 'Yo tout alé, nonm kon fanm.',
  egSentenceEn: 'They all went, men as well as women.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. comme]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kon',
  partOfSpeech: 'CONJ',
  definition: ['as well as'],
  egSentenceKw: 'Yo tout alé, nonm kon fanm.',
  egSentenceEn: 'They all went, men as well as women.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. comme]',
  dialect: '🇱🇨',
  variant: [null],
},
];
